//lightIcons
import lIcon1 from "../../assets/light dash icons/dashboard.png";
import lIcon2 from "../../assets/light dash icons/english.png";
import lIcon3 from "../../assets/light dash icons/test.png";
import lIcon4 from "../../assets/light dash icons/teacher.png";
import lIcon5 from "../../assets/light dash icons/development.png";
import lIcon6 from "../../assets/light dash icons/exam.png";
import lIcon7 from "../../assets/light dash icons/edit.png";
import lIcon8 from "../../assets/light dash icons/speaking.png";
import lIcon9 from "../../assets/light dash icons/exam1.png";
import lIcon10 from "../../assets/light dash icons/books.png";
import lIcon11 from "../../assets/light dash icons/support.png";
import { SettingOutlined, CreditCardOutlined } from "@ant-design/icons";
//darkIcons
import dIcon1 from "../../assets/dark dash icons/dashboard.png";
import dIcon2 from "../../assets/dark dash icons/english.png";
import dIcon3 from "../../assets/dark dash icons/test.png";
import dIcon4 from "../../assets/dark dash icons/teacher.png";
import dIcon5 from "../../assets/dark dash icons/development.png";
import dIcon6 from "../../assets/dark dash icons/exam.png";
import dIcon7 from "../../assets/dark dash icons/edit.png";
import dIcon8 from "../../assets/dark dash icons/speaking.png";
import dIcon9 from "../../assets/dark dash icons/exam1.png";
import dIcon10 from "../../assets/dark dash icons/books.png";
import dIcon11 from "../../assets/dark dash icons/support.png";

export const stdSideDashItems = [
  {
    key: "1",
    link: "/dashboard",
    darkIcon: dIcon1,
    lightIcon: lIcon1,
  },
  {
    key: "2",
    link: "/dashboard/developing-enLang-skills",
    darkIcon: dIcon2,
    lightIcon: lIcon2,
  },
  {
    key: "3",
    link: "/dashboard/placement-test",
    darkIcon: dIcon3,
    lightIcon: lIcon3,
  },
  {
    key: "4",
    link: "/dashboard/ielts-lessons",
    darkIcon: dIcon4,
    lightIcon: lIcon4,
  },
  {
    key: "5",
    link: "/dashboard/developing-ielts-skills",
    darkIcon: dIcon5,
    lightIcon: lIcon5,
  },
  {
    key: "6",
    link: "/dashboard/queTypeTraining-fullSec",
    darkIcon: dIcon6,
    lightIcon: lIcon6,
  },
  {
    key: "7",
    link: "/dashboard/std-writing-correction",
    darkIcon: dIcon7,
    lightIcon: lIcon7,
  },
  {
    key: "8",
    link: "/dashboard/std-speaking-correction",
    darkIcon: dIcon8,
    lightIcon: lIcon8,
  },
  {
    key: "9",
    link: "/dashboard/realistic-tests",
    darkIcon: dIcon9,
    lightIcon: lIcon9,
    type: "group",
    children: [
      {
        key: "9-1",
        link: "/dashboard/realistic-tests#test1",
      },
      {
        key: "9-2",
        link: "/dashboard/realistic-tests#test2",
      },
      {
        key: "9-3",
        link: "/dashboard/realistic-tests#test3",
      },
      {
        key: "9-4",
        link: "/dashboard/realistic-tests#test4",
      },
      {
        key: "9-5",
        link: "/dashboard/realistic-tests#test5",
      },
      {
        key: "9-6",
        link: "/dashboard/realistic-tests#test6",
      },
    ],
  },
  {
    key: "10",
    link: "/dashboard/library",
    darkIcon: dIcon10,
    lightIcon: lIcon10,
  },
  {
    key: "11",
    link: "/dashboard/support",
    darkIcon: dIcon11,
    lightIcon: lIcon11,
  },
];

export const teacSideDashItems = [
  {
    key: "1",
    link: "/dashboard",
    darkIcon: dIcon1,
    lightIcon: lIcon1,
  },
  {
    key: "2",
    link: "/dashboard/submissions-inbox",
    darkIcon: dIcon2,
    lightIcon: lIcon2,
  },
  {
    key: "3",
    link: "/dashboard/teac-writing-correction",
    darkIcon: dIcon7,
    lightIcon: lIcon7,
  },
  {
    key: "4",
    link: "/dashboard/teac-speaking-correction",
    darkIcon: dIcon8,
    lightIcon: lIcon8,
  },
  {
    key: "5",
    link: "/dashboard/balance",
    ico: <CreditCardOutlined />,
  },
  {
    key: "6",
    link: "/dashboard/settings",
    ico: <SettingOutlined />,
  },
  {
    key: "7",
    link: "/dashboard/support",
    darkIcon: dIcon11,
    lightIcon: lIcon11,
  },
];
